export default "__VITE_ASSET__Bc$EcSZ5__"